import React from "react";
import { Smile, Medal, ChartLine, Users } from "lucide-react";
const stats = [{
  icon: Smile,
  text: "Meer dan 1000 tevreden klanten"
}, {
  icon: Medal,
  text: "Meer dan 15 jaar ervaring in asbest"
}, {
  icon: ChartLine,
  text: "Beste prijzen in Vlaanderen"
}, {
  icon: Users,
  text: "Specialisten in hun vakgebied"
}];
export default function OurImpact() {
  return <section id="onze-impact" className="bg-muted py-20 px-8 w-full">
      <div className="max-w-7xl mx-auto flex flex-col items-center">
        <h2 className="text-foreground font-serif text-[26px] font-bold mb-10 text-center">
          Why us?
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 w-full">
          {stats.map((stat, i) => {
          const Icon = stat.icon;
          return <div key={i} data-index={i} className="flex flex-col items-center text-center gap-4">
                <Icon className="w-16 h-16 text-primary" strokeWidth={1.5} />
                <p className="text-foreground font-sans text-lg font-bold">
                  {stat.text}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}